import { render, staticRenderFns } from "./ContrattiEmailTokenFirmaView.vue?vue&type=template&id=1a9c18cd&"
import script from "./ContrattiEmailTokenFirmaView.vue?vue&type=script&lang=ts&"
export * from "./ContrattiEmailTokenFirmaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports